module.exports = __webpack_public_path__ + "static/slide10-58e91ec17e837f8478d80961e0d49fed.jpg";